export default __webpack_public_path__ + "84ecd97f12c3e94a9adf0d3e23a60ccd.svg";